import { createActionGroup, props } from '@ngrx/store';
import { GetUserDataSuccessPayload, User, UserError } from './user.interface';

export const UserActions = createActionGroup({
  source: 'User',
  events: {
    'Get user': undefined,
    'Get user success': props<{ user: GetUserDataSuccessPayload }>(),
    'Get user failure': props<{ payload: UserError }>(),
    'Set home user': props<{ user: User }>(),
  },
});

export type GetUserActionUnion = ReturnType<(typeof UserActions)[keyof typeof UserActions]>;

export type GetUserAction = ReturnType<typeof UserActions.getUser>;
export type GetUserSuccessAction = ReturnType<typeof UserActions.getUserSuccess>;
export type GetUserFailureAction = ReturnType<typeof UserActions.getUserFailure>;
export type SetHomeUserAction = ReturnType<typeof UserActions.setHomeUser>;
